'use client';

import { Mail, Shield, ArrowLeft } from 'lucide-react';
import { BRAND } from "@/lib/brand";
import Link from 'next/link';

export default function SupportPage() {
  return (
    <div className="min-h-screen bg-white px-6 py-12">
      <div className="max-w-3xl mx-auto">
        <Link href="/" className="inline-flex items-center text-gray-600 hover:text-gray-900 transition-colors mb-8">
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to home
        </Link>

        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Support & Security
        </h1>
        <p className="text-lg text-gray-600 mb-12">
          Get help with {BRAND.name} or report security issues
        </p>

        <div className="space-y-8">
          {/* General Support */}
          <div className="border border-gray-200 rounded-lg p-6">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <Mail className="h-6 w-6 text-gray-900" />
              </div>
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-2">
                  General Support
                </h2>
                <p className="text-gray-600 mb-4">
                  Need help with {BRAND.name}? Have questions or feedback? We're here to help.
                </p>
                <a
                  href="mailto:support@trycommons.com"
                  className="inline-flex items-center text-gray-900 hover:text-gray-700 font-medium transition-colors"
                >
                  support@trycommons.com
                  <Mail className="ml-2 h-4 w-4" />
                </a>
              </div>
            </div>
          </div>

          {/* Security Issues */}
          <div className="border border-gray-200 rounded-lg p-6">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <Shield className="h-6 w-6 text-red-600" />
              </div>
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-2">
                  Security & Vulnerabilities
                </h2>
                <p className="text-gray-600 mb-4">
                  Found a security issue or vulnerability? Please report it responsibly to our security team.
                </p>
                <a
                  href="mailto:support@trycommons.com"
                  className="inline-flex items-center text-red-600 hover:text-red-700 font-medium transition-colors"
                >
                  support@trycommons.com
                  <Shield className="ml-2 h-4 w-4" />
                </a>
                <p className="text-sm text-gray-500 mt-3">
                  We take security seriously and will respond to all reports promptly.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 p-6 bg-gray-50 rounded-lg">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Response Time
          </h3>
          <p className="text-gray-600">
            We typically respond to support requests within 24-48 hours on business days.
            Security issues are prioritized and will receive an immediate response.
          </p>
        </div>
      </div>
    </div>
  );
}
